import { motion } from "framer-motion";

const chapters = [
  {
    n: "01",
    title: "Why this transition is real",
    body: "Fintech, AI, robotics and ML are absorbing talent from every sector. The demand is structural, not hype — and it rewards people who arrive with adjacent skills.",
    span: "md:col-span-7",
  },
  {
    n: "02",
    title: "What employers actually want",
    body: "Not another degree. Evidence: a portfolio, a clear narrative, and the ability to speak the language of the field.",
    span: "md:col-span-5",
  },
  {
    n: "03",
    title: "Three career lanes to cross",
    body: "Build, operate, or translate. Each lane maps cleanly from a traditional background into a modern role.",
    span: "md:col-span-5",
  },
  {
    n: "04",
    title: "Your 90-day action plan",
    body: "A week-by-week scorecard that turns intent into interviews — learning architecture, networking system, and a positioning statement that lands.",
    span: "md:col-span-7",
  },
];

const card = {
  hidden: { opacity: 0, y: 40 },
  show: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] } },
};

export const Manifesto = () => {
  return (
    <section id="manifesto" className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 py-28 lg:py-40">
      <div className="max-w-3xl mb-16 lg:mb-24">
        <p className="label-caps text-white/50 mb-6">The Manifesto</p>
        <h2 className="font-origin font-light text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight">
          A bridge, not a leap. Four chapters that make the crossing feel deliberate.
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-6 lg:gap-8">
        {chapters.map((c) => (
          <motion.article
            key={c.n}
            data-testid={`manifesto-${c.n}`}
            variants={card}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-80px" }}
            className={`${c.span} rounded-2xl bg-[#121214] border border-white/5 p-8 lg:p-12 hover:border-white/20 transition-colors duration-500`}
          >
            <span className="font-mono2 text-sm text-[var(--neon-cyan)]">{c.n}</span>
            <h3 className="font-future text-xl sm:text-2xl mt-5 mb-4 tracking-tight">{c.title}</h3>
            <p className="text-white/60 leading-relaxed max-w-xl">{c.body}</p>
          </motion.article>
        ))}
      </div>
    </section>
  );
};
